<template>
    <AuthCard>
        <template v-slot:title>
            <h1>Reset Password</h1>
        </template>
        <template v-slot:form>
            <ValidationObserver v-slot="{ handleSubmit }">
                <form action="" @submit.prevent="handleSubmit(submit)">
                    <Alert type="error"
                           v-if="error"
                           :contentString="message"
                    />
                    <ValidationProvider name="email" rules="required|email|max:255" v-slot="{ errors }">
                        <p style="color: inherit !important; font-weight: normal !important; font-size: 0.9rem !important;">Enter your email address and we'll send a link to help you reset it.</p>
                        <v-text-field
                                id="email"
                                name="email"
                                label="Email Address"
                                v-model="form.email"
                                outlined
                                :dense="$vuetify.breakpoint.xsOnly"
                                :error-messages="errors[0]"
                        ></v-text-field>
                    </ValidationProvider>
                    <v-btn
                            width="100%"
                            height="48px"
                            color="primary"
                            type="submit"
                            class="mb-4"
                    >
                        Email Link
                    </v-btn>
                </form>
                <v-card-actions class="Auth__secondary-actions">
                    <v-btn text :x-small="$vuetify.breakpoint.xsOnly" to="/login">Login</v-btn>
                </v-card-actions>
                <v-dialog max-width="500" v-model="successDialog">
                    <v-card>
                        <v-card-title>
                            Email Sent!
                        </v-card-title>
                        <v-card-text>
                            An email has been sent to the address you provided. Click the link in the email to reset your password.
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="successDialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </ValidationObserver>
        </template>
    </AuthCard>
</template>
<script>
import { mapMutations } from 'vuex';
import axios from 'axios';
import Alert from '@/components/Auth/Common/Alert';
import AuthCard from '@/components/Auth/Common/AuthCard';

export default {
    components: { AuthCard, Alert },
    data() {
        return {
            error: false,
            message: '',
            form: {
                email: '',
            },
            successDialog: false,
        };
    },

    methods: {
        ...mapMutations({
            overlayToggle: 'overlay/toggle'
        }),

        submit() {
            this.error = false;
            this.overlayToggle(true);


            this.sendResetPasswordEmail(this.form.email)
                .then(() => {
                    this.successDialog = true;
                    this.overlayToggle(false);
                })

                .catch(error => {
                    this.message = error;
                    this.error = true;
                    this.overlayToggle(false);
                });
        },

        sendResetPasswordEmail(email) {
            return new Promise((resolve, reject) => {
                axios.get('/sanctum/csrf-cookie')
                    .then(() => {
                        axios.post('/api/password/email', { 'email': email })
                            .then(response => {
                                resolve(response);
                            })

                            .catch(error => {
                                reject(error.response.data.message);
                            });
                    });
            });
        },
    },
};
</script>
